export const DOMAIN = process.env.MY_DOMAIN;
// export const SF_DOMAIN = "https://ykktest.isigning.cn/paper_matting"  // 算法 接口环境地址
export const PIC_DOMAIN = process.env.MY_PIC_DOMAIN // 图片处理接口 测试
